import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { checkout } from 'PointOfSale/modules/cepCard/state/actions';
import * as POSSelectors from 'PointOfSale/selectors';
import MealCounterFooterComponent from 'PointOfSale/modules/layouts/component/MealCounterFooter';

class MealCounterFooter extends Component {
  checkout = () => {
    this.props.checkout();
  };

  render() {
    const { hasUnprocessedMeals } = this.props;
    return (
      <MealCounterFooterComponent
        checkout={this.checkout}
        disabled={!hasUnprocessedMeals}
      />
    );
  }
}

MealCounterFooter.propTypes = {
  checkout: PropTypes.func,
};

const mapStateToProps = state => ({
  hasUnprocessedMeals: POSSelectors.getHasUnprocessedMeals(state),
});

const mapDispatchToProps = {
  checkout,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MealCounterFooter);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/MealCounterFooter.js